<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="答题器数据"
      width="590px"
      :close-on-click-modal="false"
      custom-class="clicker-data-dialog"
      @close="handleDialogClose"
    >
      <div class="dialog-content">
        <!-- 学生统计部分 -->
        <div class="student-stats-section">
          <div class="top">
            <div class="section-title">学生统计</div>
            <!-- Tab 切换 -->
            <div class="tab-container">
              <div
                class="tab-item"
                :class="{ active: activeTab === 'overview' }"
                @click="handleTabChange('overview')"
              >
                概览
              </div>
              <div
                class="tab-item"
                :class="{ active: activeTab === 'detail' }"
                @click="handleTabChange('detail')"
              >
                明细
              </div>
            </div>
          </div>

          <div class="stats-container">
            <!-- 概览内容 - 饼状图 -->
            <div v-show="activeTab === 'overview'" class="overview-content">
              <div class="pie-chart-container">
                <div class="pie-chart" ref="pieChart"></div>
              </div>
            </div>

            <!-- 明细内容 - 表格 -->
            <div v-show="activeTab === 'detail'" class="detail-content">
              <div class="detail-table">
                <div class="table-header">
                  <div class="header-cell">序号</div>
                  <div class="header-cell">姓名</div>
                  <div class="header-cell">答对数</div>
                  <div class="header-cell">总用时</div>
                  <div class="header-cell">操作</div>
                </div>
                <div
                  class="table-body"
                  v-infinite-scroll="loadStudentDetailData"
                  infinite-scroll-immediate="false"
                  infinite-scroll-distance="50"
                  :infinite-scroll-disabled="
                    studentDetailLoadDisabled || studentDetailDataLoading
                  "
                >
                  <div
                    v-for="(item, index) in studentDetailData"
                    :key="index"
                    class="table-row"
                  >
                    <div class="row-cell">{{ index + 1 }}</div>
                    <div class="row-cell ellipsis">{{ item.nickname }}</div>
                    <div class="row-cell">{{ item.right_num }}</div>
                    <div class="row-cell">
                      {{ formatTimeBySecond(item.total_time) }}
                    </div>
                    <div class="row-cell">
                      <span
                        class="view-btn"
                        @click="handleClickViewDetail(item)"
                      >
                        查看
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 答题统计部分 -->
        <div class="answer-stats-section">
          <div class="top">
            <div class="section-title">答题统计</div>
            <!-- 排序选择器 -->
            <div class="sort-selector">
              <el-select
                v-model="sortType"
                placeholder="请选择"
                size="small"
                @change="onChangeSort"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="stats-info">
            <div class="info-item">
              <div class="info-value">
                {{ formatTimeBySecond(answerOverview.total_time) }}
              </div>
              <div class="info-label">总用时</div>
            </div>
            <div class="divider"></div>
            <div class="info-item">
              <div class="info-value">
                {{
                  (answerOverview.question_type_map &&
                    answerOverview.question_type_map["2"]) ||
                  0
                }}
              </div>
              <div class="info-label">多选题</div>
            </div>
            <div class="divider"></div>
            <div class="info-item">
              <div class="info-value">
                {{
                  (answerOverview.question_type_map &&
                    answerOverview.question_type_map["1"]) ||
                  0
                }}
              </div>
              <div class="info-label">单选题</div>
            </div>
            <div class="divider"></div>
            <div class="info-item">
              <div class="info-value">
                {{
                  (answerOverview.question_type_map &&
                    answerOverview.question_type_map["3"]) ||
                  0
                }}
              </div>
              <div class="info-label">判断题</div>
            </div>
          </div>
          <!-- 答题统计表格 -->
          <div class="answer-table">
            <div class="table-header">
              <div class="header-cell" style="width: 120px; min-width: 120px">
                题目
              </div>
              <div
                class="header-cell"
                style="width: 120px; min-width: 120px; text-align: left"
              >
                题型
              </div>
              <div class="header-cell" style="width: 120px; min-width: 120px">
                正确率
              </div>
              <div class="header-cell">用时</div>
            </div>
            <div
              class="table-body"
              v-infinite-scroll="loadAnswerlData"
              infinite-scroll-immediate="false"
              infinite-scroll-distance="50"
              :infinite-scroll-disabled="
                answerDataLoadDisabled || answerDataLoading
              "
            >
              <div
                v-for="(item, index) in answerData"
                :key="index"
                class="table-row"
              >
                <div class="row-cell" style="width: 120px; min-width: 120px">
                  第{{ item.question_num }}题
                </div>
                <div
                  class="row-cell"
                  style="text-align: left; width: 120px; min-width: 120px"
                >
                  {{ questionTypeMap[item.question_type] }}
                </div>
                <div class="row-cell" style="width: 120px; min-width: 120px">
                  {{ getRightPercent(item) }}
                </div>
                <div class="row-cell">
                  {{ formatTimeBySecond(item.end_time - item.start_time) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <ClickerDataStudentDetailDialog
      :visible.sync="studentDetailVisible"
      :studentInfo="studentInfo"
      :liveReport="liveReport"
    ></ClickerDataStudentDetailDialog>
  </div>
</template>

<script>
import {
  getQuestionAnswerStatic,
  getQuestionStaticData,
  getStudentAnswerStatic,
} from "@saas/server-api/src/live-data";
import { formatTimeBySecond } from "@saas/components/src";
// 引入 echarts 核心模块
import * as echarts from "echarts/core";
// 引入饼图图表
import { PieChart } from "echarts/charts";
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件
import { TooltipComponent, LegendComponent } from "echarts/components";
// 标签自动布局、全局过渡动画等特性
import { LabelLayout } from "echarts/features";
// 引入 Canvas 渲染器
import { CanvasRenderer } from "echarts/renderers";

// 注册必须的组件
echarts.use([
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
]);
import ClickerDataStudentDetailDialog from "./ClickerDataStudentDetailDialog.vue";
export default {
  name: "ClickerDataDialog",
  components: {
    ClickerDataStudentDetailDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    liveReport: {
      typeof: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: "overview", // overview 概览, detail 明细
      pieChart: null,
      // 学生明细列表
      studentDetailData: [],
      // 学生明细页码信息
      studentDetailPageInfo: {
        page: 1,
        pageSize: 5,
        total: 0,
      },
      studentDetailDataLoading: false,
      // 答题统计列表
      answerData: [],
      answerDataPageInfo: {
        page: 1,
        pageSize: 5,
        total: 0,
      },
      answerDataLoading: false,
      // 答题统计
      answerOverview: {},
      rightNumData: {},
      formatTimeBySecond,
      sortType: "",
      options: [
        {
          value: "",
          label: "默认排序",
        },
        {
          value: "desc",
          label: "按正确率排序",
        },
        {
          value: "asc",
          label: "按错误率排序",
        },
      ],
      questionTypeMap: {
        1: "单选题",
        2: "多选题",
        3: "判断题",
      },
      studentDetailVisible: false,
      studentInfo: {},
    };
  },
  computed: {
    studentDetailLoadDisabled() {
      return this.studentDetailPageInfo.total <= this.studentDetailData.length;
    },
    answerDataLoadDisabled() {
      return this.answerDataPageInfo.total <= this.answerData.length;
    },
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          this.getQuestionStaticData();
          this.getStudentAnswerStatic();
          this.getQuestionAnswerStatic();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 获取学生答题统计
    getQuestionStaticData() {
      getQuestionStaticData({
        room_id: this.liveReport.room_id,
      }).then((res) => {
        if (res.code === 1) {
          this.answerOverview = res.data;
          this.rightNumData = res.data.question_right_map || {};
          this.initPieChart();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取学生答题统计
    getStudentAnswerStatic() {
      if (this.studentDetailDataLoading) {
        return;
      }
      this.studentDetailDataLoading = true;
      getStudentAnswerStatic({
        room_id: this.liveReport.room_id,
        page_no: this.studentDetailPageInfo.page,
        page_size: this.studentDetailPageInfo.pageSize,
      })
        .then((res) => {
          if (res.code === 1) {
            const list = res.data.list || [];
            this.studentDetailData = [...this.studentDetailData, ...list];
            this.studentDetailPageInfo.total = res.data.total;
            this.studentDetailPageInfo.page++;
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.studentDetailDataLoading = false;
        });
    },
    getQuestionAnswerStatic() {
      console.log(this.answerDataLoading);

      if (this.answerDataLoading) {
        return;
      }
      this.answerDataLoading = true;
      getQuestionAnswerStatic({
        is_asc: this.sortType, // 默认为''',  desc正确率从高到低， asc 正确率从低到高
        room_id: this.liveReport.room_id,
        page_no: this.answerDataPageInfo.page,
        page_size: this.answerDataPageInfo.pageSize,
      })
        .then((res) => {
          if (res.code === 1) {
            const list = res.data.list || [];
            this.answerData = [...this.answerData, ...list];
            this.answerDataPageInfo.total = res.data.total;
            this.answerDataPageInfo.page++;
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.answerDataLoading = false;
        });
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
    handleTabChange(tab) {
      this.activeTab = tab;
    },
    initPieChart() {
      if (this.pieChart) {
        this.pieChart.dispose();
      }

      const dom = this.$refs.pieChart;
      if (!dom) return;

      this.pieChart = echarts.init(dom);
      const data = Object.keys(this.rightNumData)
        .map((item) => {
          return {
            value: this.rightNumData[item],
            name: `对${item}道`,
          };
        })
        .filter((item) => item.value);
      const option = {
        series: [
          {
            type: "pie",
            radius: ["30%", "50%"],
            center: ["50%", "50%"],
            data: data,
            label: {
              alignTo: "edge",
              formatter: "{name|{b}}\n{percent|{c} ({d}%)}",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              fontSize: 14,
              distanceToLabelLine: 4,
              rich: {
                percent: {
                  fontSize: 12,
                  color: "#4E5969",
                },
              },
            },
            labelLine: {
              length: 15,
              length2: 0, // 增加第二段引导线长度
              maxSurfaceAngle: 80,
              lineStyle: {
                color: "#C9CDD4",
              },
            },
            labelLayout: (params) => {
              console.log("params", params);
              const isLeft = params.labelRect.x < this.pieChart.getWidth() / 2;
              const points = params.labelLinePoints;
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width;
              return {
                labelLinePoints: points,
              };
            },
          },
        ],
      };

      this.pieChart.setOption(option);
    },
    onChangeSort() {
      this.answerData = [];
      this.answerDataPageInfo.page = 1;
      this.getQuestionAnswerStatic();
    },
    getRightPercent(item) {
      if (!item.total_user_num) {
        return "0%";
      } else {
        return (
          Math.floor((item.right_user_num / item.total_user_num) * 100) + "%"
        );
      }
    },
    handleClickViewDetail(data) {
      this.studentDetailVisible = true;
      this.studentInfo = data;
    },
    loadStudentDetailData() {
      this.getStudentAnswerStatic();
    },
    loadAnswerlData() {
      console.log("loadAnswerlData___");

      this.getQuestionAnswerStatic();
    },
  },
  beforeDestroy() {
    if (this.pieChart) {
      this.pieChart.dispose();
    }
  },
};
</script>

<style lang="scss" scoped>
// 弹窗样式
::v-deep .clicker-data-dialog {
  border-radius: 24px;
  overflow: hidden;

  .el-dialog__header {
    padding: 24px 24px 0;
    border-bottom: none;

    .el-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: #0d1400;
      line-height: 1.4;
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 24px;
      width: 24px;
      height: 24px;

      .el-dialog__close {
        color: #4e5969;
        font-size: 14px;
        font-weight: normal;
      }
    }
  }

  .el-dialog__body {
    padding: 14px 24px 24px;
  }
}

.dialog-content {
  .student-stats-section {
    width: 542px;
    min-height: 221px;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #e5e6eb;
    margin-bottom: 20px;
    padding: 14px;
    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .section-title {
      font-weight: 600;
      font-size: 14px;
      color: #0d1400;
    }
    .tab-container {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f7f8fa;
      border: 1px solid #f2f3f5;
      border-radius: 12px;
      width: 116px;
      height: 40px;
      .tab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 52px;
        height: 32px;
        border-radius: 8px 8px 8px 8px;
        border-radius: 8px;
        font-weight: 500;
        color: #4e5969;
        cursor: pointer;
        font-weight: 400;
        font-size: 14px;
        color: #4e5969;
        &:first-child {
          margin-right: 4px;
        }
        &.active {
          background: #fff;
          color: #1d2129;
          font-weight: 600;
          box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
          border: 1px solid rgba(229, 231, 235, 0.72);
          font-weight: 600;
          color: #1d2129;
        }
      }
    }
    .stats-container {
      .overview-content {
        .pie-chart-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 40px;

          .pie-chart {
            width: 400px;
            height: 200px;
          }

          .chart-legend {
            .legend-item {
              display: flex;
              align-items: center;
              gap: 8px;
              margin-bottom: 12px;

              .legend-color {
                width: 12px;
                height: 12px;
                border-radius: 50%;
              }

              .legend-text {
                font-size: 14px;
                color: #4e5969;
                font-weight: 500;
                min-width: 50px;
              }

              .legend-percent {
                font-size: 12px;
                color: #4e5969;
                font-weight: 500;
              }
            }
          }
        }
      }

      .detail-content {
        .detail-table {
          .table-header {
            display: flex;
            padding: 8px 19px 10px;
            .header-cell {
              font-size: 12px;
              color: #515350;
              font-weight: 400;

              &:nth-child(1) {
                width: 60px;
                text-align: left;
              }
              &:nth-child(2) {
                width: 100px;
                text-align: left;
                flex: 1;
              }
              &:nth-child(3) {
                width: 80px;
                text-align: right;
              }
              &:nth-child(4) {
                width: 100px;
                text-align: right;
              }
              &:nth-child(5) {
                width: 80px;
                text-align: right;
              }
            }
          }

          .table-body {
            height: 140px;
            max-height: 140px;
            overflow: auto;
            .table-row {
              background: #f7f8fa;
              border-radius: 12px;
              padding: 10px 19px;
              margin-bottom: 8px;
              display: flex;
              align-items: center;

              .row-cell {
                font-size: 14px;
                color: #1d2129;

                &:nth-child(1) {
                  width: 60px;
                  text-align: left;
                }
                &:nth-child(2) {
                  width: 100px;
                  text-align: left;
                  flex: 1;
                }
                &:nth-child(3) {
                  width: 80px;
                  text-align: right;
                }
                &:nth-child(4) {
                  width: 100px;
                  text-align: right;
                }
                &:nth-child(5) {
                  width: 80px;
                  text-align: right;
                }

                .view-btn {
                  color: #165dff;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
  }

  .answer-stats-section {
    width: 542px;
    height: 306px;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #e5e6eb;
    padding: 14px;
    display: flex;
    flex-direction: column;
    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .section-title {
        font-weight: 600;
        font-size: 14px;
        color: #0d1400;
      }
      .sort-selector ::v-deep {
        display: flex;
        align-items: center;
        gap: 2px;
        margin-left: auto;
        width: fit-content;
        cursor: pointer;

        .el-select {
          border: none;
          width: 130px;
          input {
            border: none;
            text-align: right;
            padding-right: 32px;
          }
        }
      }
    }

    .stats-info {
      width: 511px;
      height: 56px;
      background: #f7f8fa;
      border-radius: 12px 12px 12px 12px;
      display: flex;
      align-items: center;
      gap: 18px;
      padding: 0 10px;
      .info-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;
        &:first-child {
          min-width: 110px;
        }
        .info-value {
          font-size: 20px;
          font-weight: 700;
          color: #0d1400;
          // font-family: "DIN Alternate", monospace;
        }

        .info-label {
          font-size: 12px;
          color: #515350;
        }
      }

      .divider {
        width: 1px;
        height: 36px;
        background: linear-gradient(
          180deg,
          rgba(244, 244, 247, 0) 0%,
          rgba(242, 242, 245, 1) 14%,
          rgba(231, 232, 236, 1) 89%,
          rgba(229, 230, 235, 0) 100%
        );
      }
    }

    .answer-table {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .table-header {
        display: flex;
        padding: 0 10px 0px;
        .header-cell {
          height: 35px;
          line-height: 35px;
          font-size: 12px;
          color: #515350;
          font-weight: 400;

          &:nth-child(1) {
            width: 100px;
            text-align: left;
            flex: 1;
          }
          &:nth-child(2) {
            width: 80px;
            text-align: right;
            flex: 1;
          }
          &:nth-child(3) {
            width: 80px;
            text-align: right;
            flex: 1;
          }
          &:nth-child(4) {
            width: 80px;
            text-align: right;
            flex: 1.5;
          }
        }
      }

      .table-body {
        flex: 1;
        overflow: auto;
        .table-row {
          border-radius: 12px;
          padding: 10px;
          display: flex;
          align-items: center;
          &:nth-of-type(odd) {
            background: #f7f8fa;
          }
          .row-cell {
            font-size: 14px;
            color: #1d2129;

            &:nth-child(1) {
              text-align: left;
              flex: 1;
            }
            &:nth-child(2) {
              text-align: right;
              flex: 1;
            }
            &:nth-child(3) {
              text-align: right;
              flex: 1;
            }
            &:nth-child(4) {
              text-align: right;
              flex: 1.5;
            }
          }
        }
      }
    }
  }
}
</style>
